import React, { useEffect, useState } from "react";

import {
  MdGroups,
  MdWork,
  MdHome,
  MdDesignServices,
  MdAccountBalance,
  MdMonetizationOn,
  MdConfirmationNumber,
  MdPendingActions,
  MdMenuBook,
  MdAddCircle,
  MdBusiness,
  MdTimer,
  MdWarning,
  MdAssignment,
  MdShoppingBasket,
  MdAccountBalanceWallet,
  MdChat,
} from "react-icons/md";

import {
  FaDraftingCompass,
  FaFileContract,
  FaLayerGroup,
  FaRegImages,
  FaTicketAlt,
  FaUsers,
} from "react-icons/fa";
import { MdHelp } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";

import { Menu } from "antd";
import "./style.css";

const MenuOptions = ({ type }) => {
  const navigate = useNavigate();
  const local = useLocation();

  const [route, setRoute] = useState("");

  useEffect(() => {
    options.map((item, index) => {
      if (item.route == local.pathname) {
        setRoute(`${index}`);
      }
    });
  }, [local]);

  //

  const options = [
    {
      name: "Home",
      route: `/`,
      icon: <MdHome size={20} />,
    },
    {
      name: "Usuárias",
      route: `/users`,
      icon: <FaUsers size={20} />,
    },
    {
      name: "Receitas",
      route: `/nutritions`,
      icon: <MdShoppingBasket size={20} />,
    },
    {
      name: "Exercícios",
      route: `/exercises`,
      icon: <MdTimer size={20} />,
    },
    {
      name: "Artigos",
      route: `/articles`,
      icon: <MdMenuBook size={20} />,
    },
    {
      name: "Dicas",
      route: `/insights`,
      icon: <FaRegImages size={20} />,
    },
    {
      name: "Notificações",
      route: `/notifications`,
      icon: <MdChat size={20} />,
    },
    {
      name: "Pagamentos",
      route: `/payments`,
      icon: <MdMonetizationOn size={20} />,
    },
  ];

  return (
    <Menu mode="inline" className="menu" selectedKeys={[route]}>
      {options.map((item, index) => {
        return (
          <Menu.Item
            key={index}
            onClick={(changeSelectedKey) => {
              setRoute(changeSelectedKey.key);
              navigate(item.route);
            }}
            className="option"
            type="primary"
            icon={item.icon}
          >
            {item.name}
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

export default MenuOptions;
